import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  ADD_PACKAGES_TO_CART,
  CLEAR_CART,
  GET_PACKAGES_COSTS_ERROR,
  GET_PACKAGES_COSTS_REQUEST,
  GET_PACKAGES_COSTS_SUCCESS,
  INITIALIZE_CART,
  PUT_USER_SUBSCRIBED_PACKAGES,
  REMOVE_PACKAGE_FROM_CART,
  RESET_CART_AND_ADDITIONAL_USERS,
  SET_SUBSCRIPTION_STATUS,
  SUBSCRIBE_TO_PACKAGES_REQUEST,
  SUBSCRIBE_TO_PACKAGES_SUCCESS,
} from 'modules/cart/actions';
import {
  addNewPackagesToCachedAdditionalUsersInCart,
  getAddedPackagesFromDependencies,
  getUniqueSimpleArray,
} from 'modules/cart/helpers';
import { CART_PACKAGES_LOCAL_STORAGE_KEY } from 'const/cartPage';
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
} from 'helpers/storage';

const initialState = {
  currentItems: [],
  status: STATUS_NOT_REQUESTED,
  shouldBeReseted: false,
  packagesCosts: {},
  packagesCostsStatus: STATUS_NOT_REQUESTED,
  userSubscribedPackages: [],
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUT_USER_SUBSCRIBED_PACKAGES:
      return {
        ...state,
        userSubscribedPackages: action.payload.packages,
      };

    case ADD_PACKAGES_TO_CART: {
      const { packageName } = action.payload;
      const currentUserPackages = state.userSubscribedPackages;
      const currentCartPackagesInState = state.currentItems;

      if (currentUserPackages.includes(packageName)) {
        return state;
      }

      const packageWithMainDependency = getAddedPackagesFromDependencies(
        packageName,
        currentUserPackages
      );

      addNewPackagesToCachedAdditionalUsersInCart(
        packageWithMainDependency,
        currentCartPackagesInState
      );

      const currentStoredPackages =
        getFromStorage({
          key: CART_PACKAGES_LOCAL_STORAGE_KEY,
          shouldBeParsed: true,
        }) || [];

      const updatedPackages = getUniqueSimpleArray([
        ...currentCartPackagesInState,
        ...currentStoredPackages,
        ...packageWithMainDependency,
      ]);

      setToStorage({
        key: CART_PACKAGES_LOCAL_STORAGE_KEY,
        value: updatedPackages,
      });

      return {
        ...state,
        currentItems: updatedPackages,
      };
    }

    case REMOVE_PACKAGE_FROM_CART: {
      const { packageName } = action.payload;
      const updatedPackages = state.currentItems.filter(
        (pack) => pack !== packageName
      );
      setToStorage({
        key: CART_PACKAGES_LOCAL_STORAGE_KEY,
        value: updatedPackages,
      });
      return {
        ...state,
        currentItems: updatedPackages,
      };
    }

    case INITIALIZE_CART: {
      const cachedCart = getFromStorage({
        key: CART_PACKAGES_LOCAL_STORAGE_KEY,
      });
      return {
        ...state,
        currentItems: cachedCart ? JSON.parse(cachedCart) : [],
      };
    }

    case CLEAR_CART:
      removeFromStorage({ key: CART_PACKAGES_LOCAL_STORAGE_KEY });
      return {
        ...state,
        currentItems: [],
      };

    case SUBSCRIBE_TO_PACKAGES_REQUEST:
      return { ...state, status: STATUS_LOADING };

    case SUBSCRIBE_TO_PACKAGES_SUCCESS:
      return { ...state, status: STATUS_SUCCESS };

    case SET_SUBSCRIPTION_STATUS:
      return { ...state, status: action.payload.value };

    case RESET_CART_AND_ADDITIONAL_USERS:
      return { ...state, shouldBeReseted: action.payload.value };

    case GET_PACKAGES_COSTS_REQUEST:
      return { ...state, packagesCostsStatus: STATUS_LOADING };

    case GET_PACKAGES_COSTS_SUCCESS:
      return {
        ...state,
        packagesCosts: action.payload.costs,
        packagesCostsStatus: STATUS_SUCCESS,
      };

    case GET_PACKAGES_COSTS_ERROR:
      return {
        ...state,
        packagesCostsStatus: STATUS_ERROR,
        packagesCosts: {},
      };

    default:
      return state;
  }
};
